// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.monthCalendar {
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loadingSpinnerLayout {
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
  overflow: hidden;
  position: fixed;
  background-color: rgba(255, 255, 255, 0.6);
  z-index: 9999;
}

:host forge-button.btn-light .forge-button--outlined:not(:disabled) {
  border-color: #e5e5e5;
}

:host forge-button.btn-light .forge-button:not(:disabled) {
  color: #999;
}

.mainSection {
  font-size: 14px;
  display: flex;
  height: 100%;
  --forge-drawer-width: 320px;
}
.mainSection .leftPanel .todayCalendarButton {
  font-size: 11px;
  color: #303590;
  text-transform: uppercase;
  position: absolute;
  left: 20px;
  top: 10px;
  cursor: default;
}
.mainSection .leftPanel forge-card {
  padding: 0;
  margin: 0;
  position: relative;
  border-radius: 4px;
  height: 100%;
  overflow-y: hidden;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
}
.mainSection .leftPanel forge-card > :first-child.color-block {
  padding-top: 10px;
  display: block;
}
.mainSection .leftPanel forge-card > .scroll-space {
  padding-right: 5px;
}
.mainSection .leftPanel:hover forge-card {
  overflow-y: auto;
}
.mainSection .leftPanel:hover forge-card > .scroll-space {
  padding-right: 0;
}
.mainSection .leftPanel .todayCalendarButton {
  font-size: 11px;
  color: #333;
  text-transform: uppercase;
  position: absolute;
  left: 20px;
  top: 10px;
  cursor: pointer;
  font-weight: 600;
}
.mainSection .leftPanel .todayCalendarButton:hover, .mainSection .leftPanel .todayCalendarButton:focus {
  color: #3f51b5;
}
.mainSection .leftPanel .agendaItem, .mainSection .leftPanel .event-agenda, .mainSection .leftPanel .publish-agenda, .mainSection .leftPanel .preview-agenda, .mainSection .leftPanel .build-agenda, .mainSection .leftPanel .meeting-type {
  color: rgba(0, 0, 0, 0.6);
  font-size: 14px;
}
.mainSection .leftPanel .meeting-type {
  margin-top: 3px;
  height: 40px;
}
.mainSection .leftPanel .meeting-type forge-checkbox.select-all {
  --forge-theme-tertiary: #ffab40;
  --forge-theme-text-medium: #ffab40;
}
.mainSection .leftPanel .meeting-type .label-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 200px;
  color: rgba(0, 0, 0, 0.87);
  font-size: 13px;
  line-height: 15px;
  padding-left: 10px;
}
.mainSection .leftPanel .meeting-type .sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
.mainSection .leftPanel .build-agenda {
  background-color: rgba(255, 193, 7, 0.28);
}
.mainSection .leftPanel .preview-agenda {
  background-color: rgba(203, 209, 235, 0.48);
}
.mainSection .leftPanel .publish-agenda {
  background-color: rgba(223, 240, 208, 0.48);
}
.mainSection .leftPanel .event-agenda {
  background-color: rgba(191, 226, 250, 0.48);
}
.mainSection .leftPanel hr {
  border: 0;
  background: rgba(0, 0, 0, 0.2);
  height: 1px;
}
.mainSection .leftPanel .color-block {
  margin: 0;
}
.mainSection .leftPanel .color-block forge-label-value {
  margin: 0px 15px 0px 15px;
  display: flex;
  justify-content: flex-start;
}
.mainSection .leftPanel .color-block forge-label-value .colorBy {
  width: 70px;
  font-size: 12px;
}
.mainSection .leftPanel .color-block forge-label-value .filter {
  font-size: 12px;
  width: 145px;
  margin: 0;
}
.mainSection .rightPanel {
  flex-grow: 1;
  padding: 20px;
}
.mainSection .rightPanel .view-block {
  align-items: center;
}
.mainSection .rightPanel .view-block.disply-flex {
  display: flex;
}
.mainSection .rightPanel .view-block forge-button {
  margin-left: 4px;
}
.mainSection .rightPanel .view-block forge-button.active {
  background-color: rgba(0, 0, 0, 0.12);
}
.mainSection .rightPanelHeight {
  height: calc(100% - 10px);
}
.mainSection .rightPanelHeight .fc-view-container {
  height: calc(100% - 40px);
}
.mainSection .rightPanelHeight .calendar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.mainSection .rightPanelHeight .calendar-header .update-calendar {
  display: flex;
  justify-content: center;
  align-items: center;
}
.mainSection .rightPanelHeight .calendar-header .update-calendar forge-icon-button {
  vertical-align: middle;
  margin-left: 10px;
}
.mainSection .rightPanelHeight .calendar-header #calendar-view-select {
  max-width: 120px;
  margin-left: 10px;
}
.mainSection .rightPanelHeight .calendar-header #button-menu {
  vertical-align: middle;
  margin-right: 10px;
  margin-left: 0px;
}
.mainSection .rightPanelHeight .calendar-header #search-bar {
  width: 160px;
}
.mainSection .rightPanelHeight .calendar-header #btnSubscription {
  margin-right: 10px;
  margin-bottom: 15px;
  --forge-button-height: 48px;
  --forge-button-padding: 16px;
}
/* Custom list schduler */
.fc-custom-list .fc-list-view {
  border-color: #ddd;
}
.fc-custom-list .fc-custom-list-container {
  padding: 8px 14px;
}
.fc-custom-list .fc-custom-list-container h1.fc-custom-dateheading {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
  font-weight: 500;
  margin: 0;
}
.fc-custom-list .fc-custom-list-container .fc-custom-list-item {
  margin: 10px;
  display: block;
  border-radius: 5px;
  padding: 3px 10px;
  cursor: pointer;
  border-left: 5px solid transparent;
  background-color: rgba(212, 212, 212, 0.7);
}

body .fc .fc-event {
  border-left-width: 5px !important;
  border-left-style: solid !important;
}

@media screen and (min-width: 0\\0 ) and (min-resolution: 72dpi) {
  .mainSection .leftPanel forge-card > .scroll-space {
    padding-right: 17px;
  }
}
.float-right {
  float: right;
}

#meeting-manager.container {
  padding: 0;
  height: 100%;
  width: 100%;
}

.fc-today-button {
  border-color: #e5e5e5 !important;
  color: #999 !important;
}

.fc-toolbar {
  margin: 0px !important;
}

.margine-top-30 {
  margin-top: -20px;
}

forge-calendar.forge-calendar {
  --forge-calendar-cell-size: calc((var(--forge-calendar-width) - 8 * 4px) / 7);
  width: 100%;
}

.forge-card-body {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.forge-card-body #meeting-type {
  height: calc(100% - 380px);
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}
.forge-card-body #meeting-type .meeting-list {
  max-height: 100%;
  overflow: auto;
}

@media (max-width: 763px) {
  .mainSection .rightPanel {
    width: calc(100% - 20px);
    padding: 10px;
  }
  .mainSection .rightPanel .rightPanelHeight {
    height: auto;
  }
  .mainSection .rightPanel .rightPanelHeight #btnSubscription {
    margin-bottom: 20px;
    --forge-button-height: 48px;
  }
}
@media (max-height: 550px) {
  .mainSection .leftPanel .forge-card-body {
    overflow: auto;
  }
  .mainSection .leftPanel .forge-card-body #meeting-type {
    height: 100%;
  }
  .mainSection .leftPanel .forge-card-body #meeting-type .meeting-list {
    max-height: max-content;
    overflow: visible;
  }
  .mainSection .rightPanelHeight #btnSubscription {
    margin-bottom: 20px;
    --forge-button-height: 48px;
  }
}
#drawerMeetingTypeSelection {
  padding: 5px 15px;
}

label[for=search-bar] {
  color: #000000;
}

.mar-lr-8px {
  margin-left: 8px;
  margin-right: 8px;
}`, "",{"version":3,"sources":["webpack://./src/app/meeting-manager/meeting-manager/meeting-manager.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACJ;;AAEA;EAAuB,YAAA;EAAa,WAAA;EAAY,OAAA;EAAQ,MAAA;EAAO,gBAAA;EAAiB,eAAA;EAAgB,0CAAA;EAA2C,aAAA;AAS3I;;AARA;EACI,qBAAA;AAWJ;;AATA;EACI,WAAA;AAYJ;;AAVA;EACI,eAAA;EACA,aAAA;EACA,YAAA;EACA,2BAAA;AAaJ;AAVQ;EACI,eAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;AAYZ;AATQ;EACI,UAAA;EACA,SAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,+GAAA;AAWZ;AATY;EACI,iBAAA;EACA,cAAA;AAWhB;AARY;EACI,kBAAA;AAUhB;AALY;EACI,gBAAA;AAOhB;AALgB;EACI,gBAAA;AAOpB;AAFQ;EACI,eAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;AAIZ;AAFY;EACI,cAAA;AAIhB;AAAQ;EACI,yBAAA;EACA,eAAA;AAEZ;AACQ;EAEI,eAAA;EACA,YAAA;AAAZ;AACY;EACI,+BAAA;EACA,kCAAA;AAChB;AACY;EACI,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,YAAA;EACA,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AAChB;AACY;EACI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AAChB;AAIQ;EAEI,yCAAA;AAHZ;AAMQ;EAEI,2CAAA;AALZ;AAQQ;EAEI,2CAAA;AAPZ;AAUQ;EAEI,2CAAA;AATZ;AAYQ;EACI,SAAA;EACA,8BAAA;EACA,WAAA;AAVZ;AAaQ;EACI,SAAA;AAXZ;AAaY;EACI,yBAAA;EACA,aAAA;EACA,2BAAA;AAXhB;AAagB;EACI,WAAA;EACA,eAAA;AAXpB;AAcgB;EACI,eAAA;EACA,YAAA;EACA,SAAA;AAZpB;AAkBI;EACI,YAAA;EACA,aAAA;AAhBR;AAkBQ;EACI,mBAAA;AAhBZ;AAiBY;EACI,aAAA;AAfhB;AAiBY;EACI,gBAAA;AAfhB;AAgBgB;EACI,qCAAA;AAdpB;AAoBI;EACI,yBAAA;AAlBR;AAoBQ;EACI,yBAAA;AAlBZ;AAqBQ;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AAnBZ;AAqBY;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AAnBhB;AAoBgB;EACI,sBAAA;EACA,iBAAA;AAlBpB;AAsBY;EACI,gBAAA;EACA,iBAAA;AApBhB;AAuBY;EACI,sBAAA;EACA,kBAAA;EACA,gBAAA;AArBhB;AAwBY;EACI,YAAA;AAtBhB;AAyBY;EACI,kBAAA;EACA,mBAAA;EACA,2BAAA;EACA,4BAAA;AAvBhB;AAgCA,yBAAA;AAEI;EACI,kBAAA;AA/BR;AAiCI;EACI,iBAAA;AA/BR;AAgCQ;EACI,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,SAAA;AA9BZ;AAgCQ;EACI,YAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,kCAAA;EACA,0CAAA;AA9BZ;;AAoCA;EAEI,iCAAA;EACA,mCAAA;AAlCJ;;AAqCA;EACI;IAAmD,mBAAA;EAjCrD;AACF;AAoCA;EACI,YAAA;AAlCJ;;AAqCA;EACI,UAAA;EACA,YAAA;EACA,WAAA;AAlCJ;;AAqCA;EACI,gCAAA;EAAgC,sBAAA;AAjCpC;;AAoCA;EACI,sBAAA;AAjCJ;;AAoCA;EACI,iBAAA;AAjCJ;;AAoCA;EACI,6EAAA;EACA,WAAA;AAjCJ;;AAmCA;EAEI,YAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAjCJ;AAmCI;EACI,0BAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AAjCR;AAmCQ;EACI,gBAAA;EACA,cAAA;AAjCZ;;AAsCA;EAEQ;IACI,wBAAA;IACA,aAAA;EApCV;EAsCU;IACI,YAAA;EApCd;EAqCc;IACI,mBAAA;IACA,2BAAA;EAnClB;AACF;AAyCA;EAEQ;IACI,cAAA;EAxCV;EAyCU;IACI,YAAA;EAvCd;EAwCc;IACI,uBAAA;IACA,iBAAA;EAtClB;EA2CU;IACI,mBAAA;IACA,2BAAA;EAzCd;AACF;AA8CA;EACI,iBAAA;AA5CJ;;AA+CA;EACI,cAAA;AA5CJ;;AA+CA;EACI,gBAAA;EACA,iBAAA;AA5CJ","sourcesContent":[".monthCalendar {\r\n    overflow: hidden;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.loadingSpinnerLayout {height: 100%;width: 100%;left: 0;top: 0;overflow: hidden;position: fixed;background-color: rgba(255, 255, 255, 0.6);z-index: 9999;}\r\n:host forge-button.btn-light .forge-button--outlined:not(:disabled) {\r\n    border-color: #e5e5e5;\r\n}\r\n:host forge-button.btn-light .forge-button:not(:disabled) {\r\n    color: #999;\r\n}\r\n.mainSection {\r\n    font-size: 14px;\r\n    display: flex;\r\n    height: 100%;\r\n    --forge-drawer-width: 320px;\r\n\r\n    .leftPanel {\r\n        .todayCalendarButton {\r\n            font-size: 11px;\r\n            color: #303590;\r\n            text-transform: uppercase;\r\n            position: absolute;\r\n            left: 20px;\r\n            top: 10px;\r\n            cursor: default;\r\n        }\r\n\r\n        forge-card {\r\n            padding: 0;\r\n            margin: 0;\r\n            position: relative;\r\n            border-radius: 4px;\r\n            height: 100%;\r\n            overflow-y: hidden;\r\n            box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);\r\n            \r\n            > :first-child.color-block {\r\n                padding-top: 10px;\r\n                display: block;\r\n            }\r\n\r\n            > .scroll-space {\r\n                padding-right: 5px;\r\n            }\r\n        }\r\n\r\n        &:hover {\r\n            forge-card {\r\n                overflow-y: auto;\r\n\r\n                > .scroll-space {\r\n                    padding-right: 0;\r\n                }\r\n            }\r\n        }\r\n\r\n        .todayCalendarButton {\r\n            font-size: 11px;\r\n            color: #333;\r\n            text-transform: uppercase;\r\n            position: absolute;\r\n            left: 20px;\r\n            top: 10px;\r\n            cursor: pointer;\r\n            font-weight: 600;\r\n\r\n            &:hover, &:focus {\r\n                color: #3f51b5;\r\n            }\r\n        }\r\n\r\n        .agendaItem {\r\n            color: rgba(0,0,0,0.6);\r\n            font-size: 14px;\r\n        }\r\n\r\n        .meeting-type {\r\n            @extend .agendaItem;\r\n            margin-top: 3px;\r\n            height: 40px;\r\n            forge-checkbox.select-all {\r\n                --forge-theme-tertiary: #ffab40;\r\n                --forge-theme-text-medium: #ffab40;\r\n            }\r\n            .label-text{\r\n                white-space: nowrap;\r\n                overflow: hidden;\r\n                text-overflow: ellipsis;\r\n                width: 200px;\r\n                color: rgba(0,0,0,.87);\r\n                font-size: 13px;\r\n                line-height: 15px;\r\n                padding-left: 10px;\r\n            }\r\n            .sr-only {\r\n                position: absolute;\r\n                width: 1px;\r\n                height: 1px;\r\n                padding: 0;\r\n                margin: -1px;\r\n                overflow: hidden;\r\n                clip: rect(0, 0, 0, 0);\r\n                white-space: nowrap;\r\n                border: 0;\r\n            }\r\n        }\r\n\r\n\r\n        .build-agenda {\r\n            @extend .agendaItem;\r\n            background-color: rgba(255,193,7,0.28);\r\n        }\r\n\r\n        .preview-agenda {\r\n            @extend .agendaItem;\r\n            background-color: rgba(203,209,235,0.48);\r\n        }\r\n\r\n        .publish-agenda {\r\n            @extend .agendaItem;\r\n            background-color: rgba(223,240,208,0.48);\r\n        }\r\n\r\n        .event-agenda {\r\n            @extend .agendaItem;\r\n            background-color: rgba(191,226,250,0.48);\r\n        }\r\n\r\n        hr {\r\n            border: 0;\r\n            background: rgba(0, 0, 0, 0.2);\r\n            height: 1px;\r\n        }\r\n\r\n        .color-block {\r\n            margin: 0;\r\n\r\n            forge-label-value {\r\n                margin: 0px 15px 0px 15px;\r\n                display: flex;\r\n                justify-content: flex-start;\r\n\r\n                .colorBy {\r\n                    width: 70px;\r\n                    font-size: 12px;\r\n                }\r\n\r\n                .filter {\r\n                    font-size: 12px;\r\n                    width: 145px;\r\n                    margin: 0;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .rightPanel {\r\n        flex-grow: 1;\r\n        padding: 20px;\r\n\r\n        .view-block {\r\n            align-items: center;\r\n            &.disply-flex{\r\n                display: flex;\r\n            }\r\n            forge-button {\r\n                margin-left: 4px;\r\n                &.active {\r\n                    background-color: rgba(0,0,0,.12);\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .rightPanelHeight {\r\n        height: calc(100% - 10px);\r\n\r\n        .fc-view-container {\r\n            height: calc(100% - 40px);\r\n        }\r\n\r\n        .calendar-header {\r\n            display: flex;\r\n            justify-content: space-between;\r\n            align-items: center;\r\n\r\n            .update-calendar {\r\n                display: flex;\r\n                justify-content: center;\r\n                align-items: center;\r\n                forge-icon-button {\r\n                    vertical-align: middle;\r\n                    margin-left: 10px;\r\n                }\r\n            }\r\n\r\n            #calendar-view-select {\r\n                max-width: 120px;\r\n                margin-left: 10px;\r\n            }\r\n            \r\n            #button-menu {\r\n                vertical-align: middle;\r\n                margin-right: 10px;\r\n                margin-left: 0px;\r\n            }\r\n\r\n            #search-bar {\r\n                width: 160px;\r\n            }\r\n\r\n            #btnSubscription {\r\n                margin-right: 10px;\r\n                margin-bottom: 15px;\r\n                --forge-button-height: 48px;\r\n                --forge-button-padding: 16px;\r\n            }\r\n        }\r\n    }\r\n\r\n    .rightPanelList {\r\n    }\r\n}\r\n\r\n/* Custom list schduler */\r\n.fc-custom-list {\r\n    .fc-list-view{\r\n        border-color: #ddd;\r\n    }\r\n    .fc-custom-list-container{\r\n        padding: 8px 14px;\r\n        h1.fc-custom-dateheading{\r\n            font-size: 14px;\r\n            color:rgba(0,0,0,0.6);\r\n            font-weight: 500;\r\n            margin: 0;\r\n        }\r\n        .fc-custom-list-item{\r\n            margin: 10px;\r\n            display: block;\r\n            border-radius: 5px;\r\n            padding: 3px 10px;\r\n            cursor: pointer;\r\n            border-left: 5px solid transparent;\r\n            background-color: rgba(212,212,212,0.7);\r\n        }\r\n    }\r\n   \r\n}\r\n//.active{background-color: red}\r\nbody .fc .fc-event {\r\n    //  border-color:transparent !important;\r\n    border-left-width: 5px!important;\r\n    border-left-style: solid !important;\r\n  }\r\n\r\n@media screen and (min-width:0\\0) and (min-resolution: +72dpi) {\r\n    .mainSection .leftPanel forge-card > .scroll-space{padding-right: 17px;}\r\n}\r\n\r\n\r\n.float-right{\r\n    float: right;\r\n}\r\n\r\n#meeting-manager.container {\r\n    padding: 0;\r\n    height: 100%;\r\n    width: 100%;\r\n}\r\n\r\n.fc-today-button {\r\n    border-color:#e5e5e5 !important;color:#999 !important;\r\n}\r\n\r\n.fc-toolbar {\r\n    margin: 0px !important;\r\n}\r\n\r\n.margine-top-30 {\r\n    margin-top: -20px;\r\n}\r\n\r\nforge-calendar.forge-calendar{\r\n    --forge-calendar-cell-size: calc((var(--forge-calendar-width) - 8 * 4px) / 7);\r\n    width: 100%;\r\n}\r\n.forge-card-body\r\n{\r\n    height: 100%;\r\n    overflow: hidden;\r\n    display: flex;\r\n    flex-direction: column;\r\n    \r\n    #meeting-type {\r\n        height: calc(100% - 380px);\r\n        flex-grow: 1;\r\n        display: flex;\r\n        flex-direction: column;\r\n        \r\n        .meeting-list {\r\n            max-height: 100%;\r\n            overflow: auto;\r\n        }\r\n    }\r\n}\r\n\r\n@media (max-width: 763px) {\r\n    .mainSection {\r\n        .rightPanel {\r\n            width: calc(100% - 20px);\r\n            padding: 10px;\r\n\r\n            .rightPanelHeight {\r\n                height: auto;\r\n                #btnSubscription {\r\n                    margin-bottom: 20px;\r\n                    --forge-button-height: 48px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@media (max-height: 550px) {\r\n    .mainSection {\r\n        .leftPanel .forge-card-body {\r\n            overflow: auto;\r\n            #meeting-type {\r\n                height: 100%;\r\n                .meeting-list {\r\n                    max-height: max-content;\r\n                    overflow: visible;\r\n                }\r\n            }\r\n        }\r\n        .rightPanelHeight {\r\n            #btnSubscription {\r\n                margin-bottom: 20px;\r\n                --forge-button-height: 48px;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n#drawerMeetingTypeSelection {\r\n    padding: 5px 15px;\r\n}\r\n\r\nlabel[for=\"search-bar\"] {\r\n    color: #000000;\r\n}\r\n\r\n.mar-lr-8px {\r\n    margin-left: 8px;\r\n    margin-right: 8px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
